import type { HeadingProps } from '@petsmart-ui/sparky';

export function getTrimmedDisplayTitle(title?: string): string | undefined {
    if (typeof title !== 'string') {
        return undefined;
    }

    const trimmed = title.trim();

    return trimmed.length > 0 ? trimmed : undefined;
}

export type PlpModuleSectionHeading = {
    title: string;
    headingTagName: HeadingProps['tagName'];
};

/**
 * Resolves section title text and heading tag for PLP top modules.
 * Blank titles (after trim) render as an empty span instead of h1/h2.
 */
export function getPlpModuleSectionHeading(title: string | undefined, isH1?: boolean): PlpModuleSectionHeading {
    const displayTitle = getTrimmedDisplayTitle(title);

    if (!displayTitle) {
        return {
            title: '',
            headingTagName: 'span' as HeadingProps['tagName'],
        };
    }

    return {
        title: displayTitle,
        headingTagName: isH1 ? 'h1' : 'h2',
    };
}
